import {
  OrganizationAuthMethodEnum,
  type OrganizationAuthMethodUpdate
} from 'src/api/main'
import { providerOrder } from 'src/features/auth/providers'

export type AuthMethodFormValues = Record<string, unknown>

type PayloadItem = OrganizationAuthMethodUpdate & { client_secret?: string }

export const buildAuthMethodsPayload = (
  values: AuthMethodFormValues
): PayloadItem[] => {
  return providerOrder.map((method) => {
    const enabled = Boolean(values[`${method}_enabled`])
    const item: PayloadItem = {
      method: method as OrganizationAuthMethodUpdate['method'],
      enabled
    }

    if (
      method === OrganizationAuthMethodEnum.GOOGLE ||
      method === OrganizationAuthMethodEnum.ENTRAID ||
      method === OrganizationAuthMethodEnum.APPLE
    ) {
      const clientId = values[`${method}_client_id`]
      const clientSecret = values[`${method}_client_secret`]
      if (typeof clientId === 'string') {
        item.client_id = clientId || null
      }
      if (typeof clientSecret === 'string' && clientSecret !== '') {
        item.client_secret = clientSecret
      }
    }

    if (
      method === OrganizationAuthMethodEnum.ENTRAID ||
      method === OrganizationAuthMethodEnum.APPLE
    ) {
      const tenantId = values[`${method}_tenant_id`]
      if (typeof tenantId === 'string') {
        item.tenant_id = tenantId || null
      }
    }

    if (method === OrganizationAuthMethodEnum.APPLE) {
      const keyId = values[`${method}_key_id`]
      if (typeof keyId === 'string') {
        ;(item as Record<string, unknown>).key_id = keyId || null
      }
    }

    return item
  })
}
